<script lang="ts">
	import { ControlsContainer } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let noWrapperContainer = false;
	export let fullContainer = false;
</script>

{#if noWrapperContainer}
	<slot />
{:else}
	<ControlsContainer
		class={fullContainer ? 'height-full' : ''}
		color={$showNewLayout ? 'color-1' : 'color-2'}
	>
		<svelte:fragment slot="first">
			<slot />
		</svelte:fragment>
	</ControlsContainer>
{/if}
